import { useSelector } from 'react-redux';
import type { RootState } from '@/state/store';
import { useAppDispatch } from './useAppDispatch';
import { logout } from '@/state/authSlice';
import { clearSession } from '@/state/sessionSlice';
import { authApi } from '@/api/auth.api';
import { broadcastLogout } from '@/utils/crossTabSync';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  // Changed based on Dinisuru's request: Expose isInitialized for silent refresh bootstrapping
  const { user, isAuthenticated, isLoading, isInitialized } = useSelector(
    (state: RootState) => state.auth,
  );

  const signOut = async () => {
    // SEC-11: Call /auth/logout to revoke the refresh token server-side and
    // clear the HttpOnly myledger_rt cookie. Best-effort — we log out locally
    // regardless of the server response.
    try {
      await authApi.logout();
    } finally {
      dispatch(clearSession());
      dispatch(logout());
      // Changed based on Dinisuru's request: Notify other open tabs to log out
      broadcastLogout();
    }
  };

  return { user, isAuthenticated, isLoading, isInitialized, signOut };
};
